import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import AttendanceTable from "./AttendanceTable";
import AttendanceModal from "./AttendanceModal";
import { getAllCOE } from "../../../services/adminServices/CoeServices";
import { getAllAttendanceRecords, downloadQrCode } from "../../../services/mentorServices/MentorServices";
import { toast } from "react-toastify";
import "../labPractice/LabPractice.css";

const Attendance = () => {
  const [openModal, setOpenModal] = useState({ userForm: false });
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [editRecord, setEditRecord] = useState(null);
  const [allCOE, setCOE] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  const handleModalToggle = (modalName, data = null) => {
    setOpenModal((prev) => ({ ...prev, [modalName]: !prev[modalName] }));
    if (!data) setEditRecord(null);
    else setEditRecord(data);
  };

  const fetchAllAttendanceRecords = async () => {
    try {
      setLoadingData(true);
      const response = await getAllAttendanceRecords();
      setAttendanceRecords(response?.data?.data || []);
      const coeResponse = await getAllCOE();
      setCOE(coeResponse?.data?.data || []);
      setLoadingData(false);
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error?.error);
    }
  };

  useEffect(() => {
    fetchAllAttendanceRecords();
  }, []);

  const handleEditClick = (record) => {
    handleModalToggle("userForm", record);
  };

  const handleDownload = async (row) => {
    const formattedStartTime = row?.lab?.startTime ? row.lab.startTime.replace(/\s/g, '') : '';
    const formattedEndTime = row?.lab?.endTime ? row.lab.endTime.replace(/\s/g, '') : '';
    try {
      const response = await downloadQrCode(row.dailyAttendanceId);
      if (response && response.data) {
        const blob = new Blob([response.data], { type: 'image/png' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `attendance-${row?.coe?.name?.trim()}-${row?.lab?.lab_name?.trim()}-${formattedStartTime}-${formattedEndTime}.png`;
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success(response?.data.message);
      } else {
        throw new Error('Invalid response data');
      }
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error?.error);
    }
  };


  return (
    <Box className="dashboard-container" >
      <Box className="dashboard-header">
        <Typography className="dashboard-header-title">
          Welcome {JSON.parse(localStorage.getItem("user"))?.name || "User"}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleModalToggle('userForm')}
          className="dashboard-header-button"
        >
          CREATE ATTENDANCE
        </Button>
      </Box>
      <AttendanceModal
        open={openModal.userForm}
        onClose={() => handleModalToggle('userForm')}
        editRecord={editRecord}
        fetchAllAttendanceRecords={fetchAllAttendanceRecords}
        allCOE={allCOE}
      />
      <Box className="dashboard-box-container" >
        <AttendanceTable
        loadingData={loadingData}
        setLoadingData={setLoadingData}
          attendanceRecords={attendanceRecords}
          handleEditClick={handleEditClick}
          fetchAllAttendanceRecords={fetchAllAttendanceRecords}
          handleDownload={handleDownload}
        />
      </Box>
    </Box>
  );
};

export default Attendance;